import React from "react";
import { styles } from "../../Form";
import {
  CssTextFieldSignIn,
  CssButtonSignIn,
  CssLink,
  CssLoginTitleTypography,
} from "../../styles/styled";
import Box from "@mui/material/Box";

function SignIn({ signIn, updateFormState, updateFormType, errMess }) {
  let errorLabel = "";
  if (errMess !== "") {
    errorLabel = <label style={styles.errorLabel}>{errMess}</label>;
  }
  return (
    <div style={styles.signInContainer}>
      <Box
        style={{
          backgroundColor: "#26890d",
          position: "absolute",
          width: "480px",
          top: 0,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <CssLoginTitleTypography>ログイン</CssLoginTitleTypography>
      </Box>
      <Box style={{ height: "30px" }}></Box>
      <label style={styles.label}>メールアドレス</label>
      <CssTextFieldSignIn
        id="signInEmail"
        defaultValue=""
        size="small"
        name="email"
        onChange={(e) => {
          e.persist();
          updateFormState(e);
        }}
      />
      <label style={styles.label}>パスワード</label>
      <CssTextFieldSignIn
        id="signInPassword"
        defaultValue=""
        size="small"
        type="password"
        name="password"
        onChange={(e) => {
          e.persist();
          updateFormState(e);
        }}
      />
      {errorLabel}
      <p
        style={{
          ...styles.toggleForm,
          fontFamily: "Noto Sans JP, Meiryo, -apple-system",
        }}
      >
        新規登録は{" "}
        <CssLink
          component="button"
          variant="body2"
          onClick={() => updateFormType("signUp")}
        >
          こちら
        </CssLink>
      </p>
      <CssButtonSignIn
        variant="contained"
        size="large"
        color="success"
        onClick={signIn}
      >
        ログイン
      </CssButtonSignIn>
    </div>
  );
}

export default SignIn;
